import { Link } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";

function FooterHome() {
  return (
    <Container className="mb-5">
      {/* Cambridge */}
      <Card className="texto-animado jumbotron-fondo text-white border-0 mb-4 rounded-4 overflow-hidden shadow-lg">
        <Card.Body className="py-5 card-overlay">
          <h1 className="display-5 fw-bold">Cambridge English School</h1>
          <p className="opacity-95 text-mobile-sm">
            Nuestro colegio forma parte del programa internacional Cambridge English School,
            lo que nos permite ofrecer una enseñanza del inglés de alta calidad, alineada con los estándares globales.
            Contamos con docentes capacitados y brindamos preparación progresiva para los exámenes de Cambridge
            (Starters, Movers, Flyers, KET, PET, FCE, CAE), otorgando certificaciones reconocidas en más de 130 países.
          </p>
          <Button as={Link} to="/InglesIntensivo" variant="warning" className="btn-hover fw-bold mt-3">
            Leer más
          </Button>
        </Card.Body>
      </Card>

      {/* Deportes */}
      <Card className="texto-animado deportes-fondo text-white border-0 mb-4 rounded-4 overflow-hidden shadow-lg">
        <Card.Body className="py-5 card-overlay">
          <h1 className="display-5 fw-bold">Deportes</h1>
          <p className="opacity-75 text-mobile-sm">
            Nuestro Departamento de Deportes considera a la actividad física como un pilar fundamental en la
            formación integral de los alumnos. A través del deporte promovemos valores como el respeto,
            el compañerismo, la disciplina y el esfuerzo, fomentando un estilo de vida saludable y equilibrado.
            Las experiencias deportivas también ofrecen oportunidades de crecimiento personal y social, especialmente mediante
            actividades de intercambio cultural con otras instituciones del país y del exterior. Estas vivencias enriquecen el
            desarrollo de nuestros estudiantes, fortalecen su autonomía y amplían su mirada del mundo en el marco de una educación
            bilingüe y global.
          </p>
          <Button as={Link} to="/deportes" variant="warning" className="btn-hover fw-bold mt-3">
            Leer más
          </Button>
        </Card.Body>
      </Card>

      <Row className="g-4">
        {/* Catequesis */}
        <Col md={6}>
          <Card className="texto-animado catequesis-fondo text-white border-0 rounded-4 overflow-hidden h-100 shadow-lg">
            <Card.Body className="py-5 card-overlay">
              <h2 className="display-5 fw-bold">Catequesis</h2>
              <p className="opacity-75 text-mobile-sm">
                Acompañamos a nuestros estudiantes en su camino de fe, brindando un espacio de reflexión, encuentro con Dios y formación en los valores
                cristianos que fortalecen la comunidad y la vida cotidiana.
                Promovemos una vivencia auténtica de la espiritualidad a través de celebraciones litúrgicas, proyectos
                solidarios y momentos de oración compartida.
              </p>
              <Button as={Link} to="/catequesis" variant="success" className="btn-hover mt-3 fw-bold">
                Leer más
              </Button>
            </Card.Body>
          </Card>
        </Col>

        {/* Arte */}
        <Col md={6}>
          <Card className="texto-animado uniforme-fondo text-white border-0 rounded-4 overflow-hidden h-100 shadow-lg">
            <Card.Body className="py-5 card-overlay">
              <h2 className="display-5 fw-bold">Arte</h2>
              <p className="opacity-75 text-mobile-sm">
                En el Colegio Santo Tomás, la educación artística es parte fundamental de la formación integral. A
                través de propuestas que integran lo sensorial, lo emocional y lo cognitivo, buscamos desarrollar la
                sensibilidad, la expresión y la creatividad de los alumnos.
                Fomentamos la participación activa y reflexiva, entendiendo al arte como una herramienta
                para potenciar la imaginación, fortalecer la autoestima y desarrollar habilidades aplicables en
                todas las áreas del conocimiento.
              </p>
              <Button as={Link} to="/arteActividad" variant="success" className="btn-hover mt-3 fw-bold">
                Leer más
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default FooterHome;
